import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { reloadMasterCourses, getCountriesWithMasterCourses } from '../master-courses/actions';
import { showToast } from '../../components/toast/actions';

export function* getCountries() {
    const payload = yield call(api.getCountries);
    if (payload.status === 200) {
        yield put(actions.getCountriesSuccess(payload.data.map(country => ({
            value: country.name,
            key: country.code }))));
    } else {
        yield put(actions.getCountriesFailure());
    }
}

export function* getDocumentsByPublication(publicationId) {
    const payload = yield call(api.getDocumentsByPublication, publicationId);
    if (payload.status === 200) {
        yield put(actions.getDocumentsByPublicationSuccess(payload.data));
    } else {
        yield put(actions.getDocumentsByPublicationFailure());
    }
}

export function* getSectionsByDocument(documentId) {
    const payload = yield call(api.getSectionsByDocument, documentId);
    if (payload.status === 200) {
        yield put(actions.getSectionsByDocumentSuccess(payload.data));
    } else {
        yield put(actions.getSectionsByDocumentFailure());
    }
}

export function* getStatesByCountry(countryCode) {
    const payload = yield call(api.getStatesByCountry, countryCode);
    if (payload.status === 200) {
        yield put(actions.getStatesByCountrySuccess(payload.data.map(state => ({
            value: state,
            key: state }))));
    } else {
        yield put(actions.getStatesByCountryFailure());
    }
}

export function* getSectionDetail(sectionId) {
    const payload = yield call(api.getSectionDetail, sectionId);
    if (payload.status === 200) {
        yield put(actions.getSectionDetailsSuccess(payload.data));
    } else {
        yield put(actions.getSectionDetailsFailure());
    }
}

export function* registerMasterCourse(sectionId, increaseVersion) {
    const response = yield call(api.registerMasterCourse, sectionId, increaseVersion);
    if (response.status === 200) {
        yield put(actions.registerMasterCourseSuccess(response.data));
        yield put(showToast('Master course registered successfully', 'success'));
        yield put(reloadMasterCourses());
        yield put(getCountriesWithMasterCourses());
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.registerMasterCourseFailure(false, response.message, false));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.registerMasterCourseFailure(true, ''));
    }
}

export function* getPublications(accessStatus) {
    const response = yield call(api.getPublications, accessStatus);
    if (response.status === 200) {
        yield put(actions.getPublicationsSuccess(response.data));
    } else {
        yield put(actions.getPublicationsFailure());
    }
}

export function* registerMasterCourseSaga() {
    yield takeLatest(actions.REGISTER_MASTER_COURSE_REQUEST, registerMasterCourse);
}

export function* getCountriesSaga() {
    yield takeLatest(actions.GET_COUNTRIES_REQUEST, getCountries);
}

export function* getDocumentsByPublicationSaga() {
    yield takeLatest(actions.GET_DOCUMENTS_BY_PUBLICATION_REQUEST, getDocumentsByPublication);
}

export function* getSectionsByDocumentSaga() {
    yield takeLatest(actions.GET_SECTIONS_BY_DOCUMENT_REQUEST, getSectionsByDocument);
}

export function* getStatesByCountrySaga() {
    yield takeLatest(actions.GET_STATES_BY_COUNTRY_REQUEST, getStatesByCountry);
}

export function* getSectionDetailsSaga() {
    yield takeLatest(actions.GET_SECTION_DETAIL_BY_ID_REQUEST, getSectionDetail);
}

export function* getPublicationsSaga() {
    yield takeLatest(actions.GET_PUBLICATIONS_REQUEST, getPublications);
}



// WEBPACK FOOTER //
// ./app/containers/curriculum-list/saga.js